/* Fouroz product page: variant picker, add to bag, gallery, lightbox, size guide, sticky bar, recommendations. */
(() => {
  const root = document.querySelector('[data-fz-pdp]');
  const cartRoot = window.Shopify?.routes?.root || '/';

  /* Complementary recommendations for the "Complete the look" rail (runs on any page that has one) */
  document.querySelectorAll('[data-fz-recs]').forEach(async section => {
    const wrapper = section.closest('.shopify-section') || section;
    try {
      const html = await (await fetch(section.dataset.url)).text();
      const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fz-recs-result]');
      if (!result || !result.children.length) { wrapper.hidden = true; return; }
      section.querySelector('[data-fz-recs-target]').append(...result.children);
      section.hidden = false;
    } catch (e) { wrapper.hidden = true; }
  });

  if (!root) return;
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
  const fmt = cents => {
    const whole = cents % 100 === 0;
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  };
  const headerHeight = () => {
    const h = document.querySelector('.fz-header-section, .shopify-section-group-header-group .fz-header');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  };
  const setHeaderVar = () => root.style.setProperty('--fz-pdp-top', `${Math.round(headerHeight())}px`);
  setHeaderVar();
  window.addEventListener('resize', setHeaderVar, { passive: true });

  /* ---------- Variants ---------- */
  const variants = JSON.parse($('[data-fz-variants]').textContent);
  const optionCount = variants[0] ? variants[0].options.length : 0;
  const selected = new Array(optionCount).fill(null);
  for (let i = 0; i < optionCount; i++) {
    const values = [...new Set(variants.map(v => v.options[i]))];
    if (values.length === 1) selected[i] = values[0];
  }
  const fromUrl = Number(new URLSearchParams(location.search).get('variant'));
  if (fromUrl) {
    const v = variants.find(x => x.id === fromUrl);
    if (v) v.options.forEach((o, i) => { selected[i] = o; });
  }
  const groups = $$('[data-fz-option]');
  const form = $('[data-fz-atc-form]');
  const atc = $('[data-fz-atc]');
  const input = $('[data-fz-variant-input]');
  const errorEl = $('[data-fz-error]');
  const sticky = $('[data-fz-sticky]');
  const stickyBtn = $('[data-fz-sticky-btn]');
  const baseVariant = variants.find(v => v.available) || variants[0];
  let current = null;
  let addedTimer = null;

  const matches = (v, skip) => v.options.every((o, i) => i === skip || selected[i] === null || selected[i] === o);
  const findCurrent = () => (selected.every(s => s !== null) ? variants.find(v => v.options.every((o, i) => o === selected[i])) : null) || null;
  const sizeIndex = () => {
    const g = groups.find(x => x.classList.contains('is-size'));
    return g ? Number(g.dataset.index) : -1;
  };

  function render() {
    current = findCurrent();
    groups.forEach(group => {
      const idx = Number(group.dataset.index);
      group.querySelector('[data-fz-option-value]').textContent = selected[idx] || 'Select';
      group.querySelectorAll('[data-fz-value]').forEach(btn => {
        const value = btn.dataset.value;
        const isSel = selected[idx] === value;
        const available = variants.some(v => v.options[idx] === value && v.available && matches(v, idx));
        btn.setAttribute('aria-pressed', String(isSel));
        btn.classList.toggle('is-sold-out', !available);
        btn.disabled = !available && !isSel;
        btn.setAttribute('aria-label', available ? value : `${value}, sold out`);
      });
    });
    const shown = current || baseVariant;
    const price = fmt(shown.price);
    $('[data-fz-price]').textContent = price;
    const onSale = shown.compare > shown.price;
    const pct = onSale ? Math.floor(((shown.compare - shown.price) * 100) / shown.compare) : 0;
    $('[data-fz-compare]').hidden = !onSale;
    $('[data-fz-compare-value]').textContent = fmt(shown.compare);
    $('[data-fz-save-text]').hidden = !onSale;
    $('[data-fz-save-badge]').hidden = !onSale;
    $$('[data-fz-save]').forEach(el => { el.textContent = pct; });

    const complete = !!current;
    if (current && !current.available) {
      atc.textContent = 'Sold out';
    } else if (!addedTimer) {
      atc.textContent = complete ? `Add to bag — ${price}` : 'Add to bag';
    }
    input.value = current ? current.id : '';
    if (current && fromUrl !== current.id) {
      const url = new URL(location.href);
      url.searchParams.set('variant', current.id);
      history.replaceState(history.state, '', url);
    }

    if (sticky) {
      $('[data-fz-sticky-price]').textContent = price;
      const si = sizeIndex();
      $('[data-fz-sticky-size]').textContent = si >= 0 && selected[si] ? ` · ${selected[si]}` : '';
      if (current && !current.available) stickyBtn.textContent = 'Sold out';
      else stickyBtn.textContent = complete ? 'Add to bag' : `Select ${groups.length ? (groups.find(g => selected[Number(g.dataset.index)] === null)?.dataset.name || 'size').toLowerCase() : 'size'}`;
    }
    highlightChart();
  }

  function clearError() {
    errorEl.hidden = true;
    groups.forEach(g => g.classList.remove('is-error'));
  }

  groups.forEach(group => {
    group.addEventListener('click', e => {
      const btn = e.target.closest('[data-fz-value]');
      if (!btn || btn.disabled) return;
      selected[Number(group.dataset.index)] = btn.dataset.value;
      clearError();
      render();
    });
  });

  function missingGroup() {
    return groups.find(g => selected[Number(g.dataset.index)] === null);
  }

  function showMissing(group) {
    const name = (group.dataset.name || 'size').toLowerCase();
    errorEl.textContent = `Please select a ${name.includes('size') ? 'size' : name}.`;
    errorEl.hidden = false;
    group.classList.add('is-error');
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const first = group.querySelector('[data-fz-value]:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  }

  function toast(text) {
    document.querySelectorAll('.fz-pdp-toast').forEach(t => t.remove());
    const el = document.createElement('div');
    el.className = 'fz-pdp-toast';
    el.setAttribute('role', 'status');
    const span = document.createElement('span');
    span.textContent = text;
    const link = document.createElement('a');
    link.href = `${cartRoot}cart`;
    link.textContent = 'View bag';
    link.addEventListener('click', ev => {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.show === 'function') { ev.preventDefault(); drawer.show(); el.remove(); }
    });
    el.append(span, link);
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 3200);
  }

  async function addToBag() {
    const missing = missingGroup();
    if (missing) { showMissing(missing); return; }
    if (!current) return;
    if (!current.available) {
      errorEl.textContent = 'This option is sold out.';
      errorEl.hidden = false;
      return;
    }
    atc.setAttribute('aria-busy', 'true');
    atc.disabled = true;
    try {
      const res = await fetch(`${cartRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
      const cart = await (await fetch(`${cartRoot}cart.js`)).json();
      document.querySelectorAll('[data-fz-cart-count]').forEach(b => { b.textContent = cart.item_count; b.hidden = cart.item_count === 0; });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      atc.textContent = 'Added to bag';
      clearTimeout(addedTimer);
      addedTimer = setTimeout(() => { addedTimer = null; render(); }, 2400);
      const si = sizeIndex();
      toast(si >= 0 ? `Added to bag · Size ${selected[si]}` : 'Added to bag');
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.show === 'function') setTimeout(() => drawer.show(), 150);
    } catch (err) {
      errorEl.textContent = err.message || 'Could not add to bag. Please try again.';
      errorEl.hidden = false;
    } finally {
      atc.removeAttribute('aria-busy');
      atc.disabled = false;
    }
  }

  form.addEventListener('submit', e => { e.preventDefault(); addToBag(); });

  /* ---------- Sticky bar (mobile) ---------- */
  if (sticky) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const show = atc.getBoundingClientRect().bottom < headerHeight();
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      stickyBtn.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    stickyBtn.addEventListener('click', () => {
      const missing = missingGroup();
      if (missing) { missing.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      addToBag();
    });
  }

  /* ---------- Gallery ---------- */
  const track = $('[data-fz-track]');
  const ref = document.referrer || '';
  let audience = '';
  if (/\/collections\/(all-men|mens-|jackets-men|men-)|[?&]view=men\b/.test(ref)) audience = 'men';
  else if (/\/collections\/(all-women|womens-|jackets-women|women-)|[?&]view=women\b/.test(ref)) audience = 'women';
  if (audience && track) {
    const first = $$(`[data-aud="${audience}"]`, track);
    if (first.length) first.slice().reverse().forEach(slide => track.prepend(slide));
  }
  if (audience === 'men' && root.hasAttribute('data-unisex')) {
    const crumb = $('[data-fz-crumb-dept]');
    if (crumb) { crumb.textContent = 'Men'; crumb.href = `${cartRoot}collections/all-men`; }
  }
  const slides = () => $$('[data-fz-slide]', track);
  slides().forEach((s, i) => {
    const img = s.querySelector('img');
    if (img && i < 2) img.loading = 'eager';
  });

  const dots = $$('.fz-pdp__dots span');
  const counter = $('[data-fz-counter]');
  if (track && dots.length) {
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const list = slides();
        const w = list[0] ? list[0].getBoundingClientRect().width : 1;
        const idx = Math.min(list.length - 1, Math.round(track.scrollLeft / w));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        if (counter) counter.textContent = idx + 1;
      });
    }, { passive: true });
  }

  /* ---------- Lightbox ---------- */
  const lb = $('[data-fz-lightbox]');
  let lbIndex = 0;
  let lbReturn = null;
  const lbImg = $('[data-fz-lightbox-img]');
  function lbShow(i) {
    const list = slides();
    if (!list.length) return;
    lbIndex = (i + list.length) % list.length;
    const s = list[lbIndex];
    lbImg.src = s.dataset.full;
    lbImg.alt = s.dataset.alt || '';
    $('[data-fz-lightbox-caption]').textContent = s.dataset.alt || '';
    $('[data-fz-lightbox-count]').textContent = `${lbIndex + 1} / ${list.length}`;
  }
  function lbOpen(i) {
    lbReturn = document.activeElement;
    lb.hidden = false;
    document.documentElement.classList.add('fz-lock');
    lbShow(i);
    $('[data-fz-lightbox-close]').focus();
  }
  function lbClose() {
    lb.hidden = true;
    document.documentElement.classList.remove('fz-lock');
    if (lbReturn) lbReturn.focus();
  }
  if (lb) {
    root.addEventListener('click', e => {
      const zoom = e.target.closest('[data-fz-zoom]');
      if (zoom) { lbOpen(slides().indexOf(zoom.closest('[data-fz-slide]'))); return; }
      const opener = e.target.closest('[data-fz-open-image]');
      if (opener) {
        const target = slides().findIndex(s => s.dataset.index === opener.dataset.fzOpenImage);
        lbOpen(Math.max(0, target));
      }
    });
    $('[data-fz-lightbox-close]').addEventListener('click', lbClose);
    $('[data-fz-lightbox-prev]').addEventListener('click', () => lbShow(lbIndex - 1));
    $('[data-fz-lightbox-next]').addEventListener('click', () => lbShow(lbIndex + 1));
    let startX = null;
    lb.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', e => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) lbShow(lbIndex + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  /* ---------- Size guide drawer ---------- */
  const guide = $('[data-fz-guide]');
  let guideReturn = null;
  function guideOpen() {
    if (!guide) return;
    guideReturn = document.activeElement;
    guide.hidden = false;
    document.documentElement.classList.add('fz-lock');
    highlightChart();
    $('[data-fz-guide-close].fz-pdp-drawer__close', guide).focus();
  }
  function guideClose() {
    guide.hidden = true;
    document.documentElement.classList.remove('fz-lock');
    if (guideReturn) guideReturn.focus();
  }
  function highlightChart() {
    if (!guide) return;
    const si = sizeIndex();
    const size = si >= 0 ? (selected[si] || '').trim().toLowerCase() : '';
    guide.querySelectorAll('table').forEach(table => {
      const head = table.rows[0];
      if (!head) return;
      let col = -1;
      Array.from(head.cells).forEach((c, i) => { if (i > 0 && size && c.textContent.trim().toLowerCase() === size) col = i; });
      Array.from(table.rows).forEach(r => Array.from(r.cells).forEach((c, i) => c.classList.toggle('is-selected', i === col)));
    });
  }
  if (guide) {
    root.addEventListener('click', e => {
      if (e.target.closest('[data-fz-guide-open]')) guideOpen();
      else if (e.target.closest('[data-fz-guide-close]')) guideClose();
    });
  }

  /* ---------- Keyboard: Esc, arrows, focus trap ---------- */
  document.addEventListener('keydown', e => {
    const open = lb && !lb.hidden ? lb : guide && !guide.hidden ? guide : null;
    if (!open) return;
    if (e.key === 'Escape') { open === lb ? lbClose() : guideClose(); return; }
    if (open === lb && e.key === 'ArrowRight') lbShow(lbIndex + 1);
    if (open === lb && e.key === 'ArrowLeft') lbShow(lbIndex - 1);
    if (e.key === 'Tab') {
      const items = Array.from(open.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])')).filter(el => !el.disabled && el.offsetParent !== null);
      if (!items.length) return;
      const firstEl = items[0];
      const lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    }
  });

  render();
})();
